module.exports={
  noResult:            'Aucun résultat correspondant'
}
